<template>
  <section>
    <div class="row my-4">
      <div class="col-md-12">
        <div class="my-4">
          <h3>แคมเปญแจก Coins</h3>
          <p>
            เชื่อมต่อ Account BeNeat ของคุณกับ Line เพื่อรับ 50 Coins ฟรี!<br>
          </p>
          <a :href="apiUrl" target="_blank">
            <img height="38" alt="Line BeNeat" src="/static/img/btn-line.png">
          </a>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    data () {
      return {
        queryData: {
          user_id: null
        },
        apiUrl: ''
      }
    },
    computed: {
      ...mapGetters({
        user: 'auth/getUser',
        state: 'user/getState'
      })
    },
    methods: {
      getUserDetail () {
        // TODO
      }
    },
    created () {
      this.$store.commit('user/SET_NO_DATA')
      if (this.$route.query.user_id) {
        this.queryData.user_id = this.$route.query.user_id
      } else if (this.user && this.user.id) {
        this.queryData.user_id = this.user.id
      }
      const code = Math.floor(Math.random() * 10000)
      const callback = encodeURIComponent(`https://beneat.co/line/callback?user_id=${this.queryData.user_id}`)
      console.log('debug', callback)
      this.apiUrl = `https://access.line.me/oauth2/v2.1/authorize?response_type=code&client_id=1653340017&redirect_uri=${callback}&code=${code}&state=${code}&scope=openid%20profile`
      this.getUserDetail()
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/information/LineLoginCampaign.vue